var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"one_code"},[(_vm.showPushRet)?_c('wx-open-launch-weapp',{attrs:{"id":"launch-btn","appid":"wxd20f2b63ea9ce6b7","username":"gh_2e2fea57f269","path":_vm.tinyPath}},[_c('script',{attrs:{"type":"text/wxtag-template"}},[_vm._v(" <style>.btn { padding: 40px }</style> <button class=\"btn\">打开小程序</button> ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }